import { chipColors } from "components/Form/Chip"

const statuses = {
    'ACTIVE': "ACTIVE",
    'BLOCK': "BLOCK",
    'SUSPENDED': "SUSPENDED"
}

const userStatusOptions = [
    { id: statuses.ACTIVE, name: "פעיל", ...chipColors.thirdly, width: 125 },
    { id: statuses.BLOCK, name: "נעול", ...chipColors.secondary, width: 125 },
    { id: statuses.SUSPENDED, name: "מושהה", ...chipColors.pink, width: 135 }
]

export { userStatusOptions }
export default statuses